module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAQAAABKfvVzAAAASElEQVQ4y2NgGAXI4L/CfwXSlD8AQllSlP//f/g/Dw2VHyFN+dH/vMS6/gBQ+Y//0qSFzv//x4i2YbBrufdfhrTEIT+ao8gDALs8VZV707tNAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/left-white-arrow.png
// module id = 136
// module chunks = 10